"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactDom = require("react-dom");

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pdfLogo = require("../assets/img/pdf/pdfLogo.png");
var ALLOWED_EXTENSIONS = ".png,.jpg,.jpeg,.pdf";
var ALLOWED_EXTENSIONS_NO_PDF = ".png,.jpg,.jpeg";

var FileUpload = function (_Component) {
    _inherits(FileUpload, _Component);

    function FileUpload(props) {
        _classCallCheck(this, FileUpload);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(FileUpload).call(this, props));

        _this.getFile = function () {
            return _this.state.file;
        };
        _this.handleFile = function (e) {
            var reader = new FileReader();
            var file = e.target.files[0];
            if (!file) {
                return;
            }
            reader.onload = function (img) {
                ReactDOM.findDOMNode(_this.refs["in"]).nodeValue = "";
                var tempTarget = img.target;
                _this.props.handleFileChange(tempTarget.result);
                if (tempTarget.result.match(/^[^;]*/)[0].indexOf("pdf") !== -1) {
                    _this.setState({
                        file: tempTarget.result,
                        src: pdfLogo
                    });
                } else {
                    _this.setState({
                        file: tempTarget.result,
                        src: tempTarget.result
                    });
                }
            };
            reader.readAsDataURL(file);
        };
        _this.state = {
            file: null,
            src: null
        };
        return _this;
    }

    _createClass(FileUpload, [{
        key: "render",
        value: function render() {
            return React.createElement("div", { className: "text-center" }, React.createElement("img", { src: this.state.src, style: { maxWidth: "auto", maxHeight: 200, paddingBottom: 10 } }), React.createElement("input", { style: { margin: "0 auto" }, ref: "in", type: "file", accept: this.props.noPdf ? ALLOWED_EXTENSIONS_NO_PDF : ALLOWED_EXTENSIONS, onChange: this.handleFile }), React.createElement("small", null, "Unterstützte Dateiendungen: ", this.props.noPdf ? ALLOWED_EXTENSIONS_NO_PDF : ALLOWED_EXTENSIONS));
        }
    }]);

    return FileUpload;
}(_react.Component);

exports.default = FileUpload;

FileUpload.propTypes = {
    handleFileChange: _react.PropTypes.func.isRequired
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FileUpload.tsx
 ** module id = 334
 ** module chunks = 0
 **/